import { useLayoutEffect, RefObject, useState, useEffect } from 'react';

export const usePreviewMask = (
  isPreview: boolean,
  contentRef: RefObject<HTMLDivElement>,
  previewHeight: number
) => {
  const [maskEnabled, setMaskEnabled] = useState(false);
  const [contentHeight, setContentHeight] = useState(previewHeight);

  useLayoutEffect(() => {
    const actualHeight = contentRef.current?.offsetHeight ?? 0;

    if (isPreview) {
      setMaskEnabled(actualHeight > previewHeight);
      setContentHeight(Math.min(previewHeight, actualHeight));
    } else {
      setMaskEnabled(false);
      setContentHeight(actualHeight);
    }
  }, [contentRef, isPreview, previewHeight]);

  return {
    maskEnabled,
    contentHeight,
  };
};

export const usePreviewOffsetTop = (isPreview: boolean, contentRef: RefObject<HTMLDivElement>) => {
  const [offsetTop, setOffsetTop] = useState(0);

  useEffect(() => {
    const [searchMatch] = contentRef.current?.getElementsByClassName('search-match') ?? [];
    if (isPreview && searchMatch && searchMatch instanceof HTMLElement) {
      setOffsetTop(searchMatch.offsetTop ?? 0);
    } else {
      setOffsetTop(0);
    }
  }, [contentRef, isPreview]);

  return { offsetTop };
};
